import { useState, useEffect } from "react";
import DesktopBanner from "./../../Public/assets/img/mcaBannerDesktop.svg";
import MobileBanner from "./../../Public/assets/img/Mobilebanner.svg";
import linkIcon from "./../../Public/assets/img/linkIcon.svg";
import planTick from "./../../Public/assets/img/planTick.svg";
// import closeIcon from "./../../Public/assets/img/closeIcon.svg";
// import moneyLogo from "./../../Public/assets/img/moneyLogo.svg";
// import flyFinance from "./../../Public/assets/img/FlyFinnace.svg";
// import { getBannerNotification, updateBannerNotification } from "../../api";
import { Logo } from "./../../Public/assets/index";
import { useTheme } from "./../../Context/Theme";

// Cookie utility functions
const setCookie = (name, value, hours = 24) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + hours * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const BorderlessMoneyBanner = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [bannerData, setBannerData] = useState(false);
  const [bannerInfo, setBannerInfo] = useState(null);
  const { themeData } = useTheme();

  useEffect(() => {
    const bannerHidden = getCookie("borderlessBannerHidden");
    if (!themeData?.data?.code) return;

    // Only show banner f theme API-WHITELABEL and not able to stockal
    if (themeData?.data?.code === "STOCKAL") {
      setBannerData(false);
      return;
    }

    // Check if banner was previously hidden via cookie

    if (bannerHidden === "true") {
      console.log("Banner hidden: Cookie is set to true");
      setBannerData(false);
      return;
    }

    // Show the banner
    console.log("Banner should be visible now");
    setBannerData(true);

    //   const fetchBannerData = async () => {
    //     try {
    //       const response = await getBannerNotification();

    //       if (response?.data) {
    //         // setBannerData(response.data?.showBanner);
    //         setBannerInfo(response?.data?.bannerInfo);
    //       }
    //     } catch (error) {
    //       console.error("Error fetching banner notification:", error);
    //     }
    //   };

    //   fetchBannerData();
  }, [themeData]);

  const onHide = async () => {
    try {
      if (
        bannerInfo &&
        Array.isArray(bannerInfo) &&
        bannerInfo.length > 0 &&
        bannerInfo[0]?.notificationID
      ) {
        // await updateBannerNotification(bannerInfo[0]?.notificationID);
      }
      // Set cookie to remember that banner was hidden (30 days)
      setCookie("borderlessBannerHidden", "true", 720);
      localStorage.setItem("isOpenMoneyAccount", "false");
      setBannerData(false);
    } catch (error) {
      console.error("Error updating banner notification:", error);
      // Still hide the banner and set cookie even if API call fails (30 days)
      setCookie("borderlessBannerHidden", "true", 720);
      setBannerData(false);
    }
  };

  const handleRedirectAction = async () => {
    try {
      setIsLoading(true);
      // const response = await generateMcaSsoToken()

      // if (response) {
      // 	const urls = (response?.data.redirectUrl || '').split(',')
      // 	const redirectUrl = urls[0]
      // 	const updatedRedirectUrl = `${redirectUrl}sso-login/${response?.data.authCode}`

      // 	if (redirectUrl) {
      // 		window.open(updatedRedirectUrl.trim(), '_blank')
      // 		onHide()
      // 	}
      // }
    } catch (error) {
      console.error("Error generating MCA SSO token:", error);
    } finally {
      setIsLoading(false);
      onHide();
    }
  };

  const partnerLogo = themeData?.data?.logo?.trim();
  const hasPartnerLogo =
    !!partnerLogo &&
    partnerLogo.toLowerCase() !== "null" &&
    partnerLogo.toLowerCase() !== "undefined";

  return (
    bannerData && (
      <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
        <div className="bg-white rounded-2xl max-w-[765px] w-[90%] max-h-[90%]  md:h-auto relative py-10 pr-0 md:pl-10 flex flex-col md:flex-row justify-between">
          {/* <div
            className="absolute -top-4 right-2.5 cursor-pointer w-[30px] h-[30px] rounded-3xl gap-1 bg-[#222222] flex justify-center items-center text-white"
            onClick={onHide}
          >
            <img className="w-4 h-4" src={closeIcon} alt="close-icon" />
          </div> */}

          {/* Desktop Content */}
          <div className="flex-col hidden w-1/2 md:flex">
            <div>
              <div className="font-geomanistMedium font-bold text-[40px] leading-[40px] text-[#3c404a]">
                Borderless
              </div>
              <div className="font-geomanistMedium font-bold text-[40px] leading-[40px] text-[#969696]">
                Account
              </div>

              <div className="flex gap-3 mt-5">
                <div className="flex items-center justify-center ">
                  {hasPartnerLogo && (
                    <div className="flex gap-4 my-2">
                      <img alt="" src={partnerLogo} width={82} height={120} />
                      <img
                        src={linkIcon}
                        alt="Link Icon"
                        className="flex items-center w-4 "
                      />

                      <div className="flex items-center justify-center">
                        <img src={Logo} alt="alt" width={120} height={120} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-1 font-geomanistregular text-xs leading-4 text-[#767c8f]">
              {themeData?.data?.name ?? ""}
              &nbsp; has partnered with Borderless to offer this multi-currency
              account. With this account, you can:
            </div>

            <div className="flex flex-col gap-2 mt-8">
              <div className="flex items-center gap-2">
                <img
                  src={planTick}
                  alt="plan-tick"
                  className="w-[15px] h-[15px]"
                />
                <span className="font-geomanistbook text-sm leading-4 text-[#3c404a]">
                  Save, spend and invest in 6 currencies
                </span>
              </div>
              <div className="flex items-center gap-2">
                <img
                  src={planTick}
                  alt="plan-tick"
                  className="w-[15px] h-[15px]"
                />
                <span className="font-geomanistbook text-sm leading-6 text-[#3c404a]">
                  Pay rent and everyday expenses
                </span>
              </div>
              <div className="flex items-center gap-2">
                <img
                  src={planTick}
                  alt="plan-tick"
                  className="w-[15px] h-[15px]"
                />
                <span className="font-geomanistbook text-sm leading-6 text-[#3c404a]">
                  Send tuition fees directly to your university
                </span>
              </div>
              <div className="flex items-center gap-2">
                <img
                  src={planTick}
                  alt="plan-tick"
                  className="w-[15px] h-[15px]"
                />
                <span className="font-geomanistbook text-sm leading-6 text-[#3c404a]">
                  Use a debit card for seamless payments
                </span>
              </div>
            </div>

            <div className="flex items-center justify-start mt-8 cursor-pointer">
              <div
                className={` h-10 rounded-[7.5px] py-3 px-8 bg-[#0062e2] flex justify-center items-center ${
                  isLoading ? "cursor-not-allowed" : "cursor-pointer"
                }`}
                onClick={!isLoading ? handleRedirectAction : undefined}
              >
                {isLoading ? (
                  <span className="border-2 border-[#f3f3f3] border-t-[#0f62fe] rounded-full w-4 h-4 animate-spin inline-block"></span>
                ) : (
                  <span className="text-sm leading-4 text-white font-geomanistbook">
                    Let's Begin
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="flex justify-center">
            {/* Desktop Image */}
            <img
              src={DesktopBanner}
              alt="Borderless Money"
              className="hidden w-auto h-auto md:block"
            />
            {/* Mobile Image */}
            <img
              src={MobileBanner}
              alt="Borderless Money"
              className="block md:hidden w-[168px] h-auto"
            />
          </div>

          {/* Mobile Content */}

          <div className="flex flex-col w-full px-5 md:hidden">
            <div className=" flex flex-col items-center justify-center leading-[28px]">
              <div className="font-geomanistBold font-normal text-[20px] leading-[32px] text-[#767C8F]">
                Open a
              </div>
              <div className="font-geomanistBold font-normal text-[24px] leading-[32px] text-[#3c404a]">
                Borderless Money
              </div>

              <div className="font-geomanistBold font-normal text-[20px] leading-[32px] text-[#767C8F]">
                Account
              </div>

              <div className="flex items-center gap-2 ">
                <div className="flex items-center justify-center">
                  {hasPartnerLogo && (
                    <div className="flex gap-4 my-2">
                      <img src={partnerLogo} alt="" width={90} height={80} />
                      <img src={linkIcon} alt="Link Icon" className="w-5 h-5" />

                      <div className="flex items-center justify-center">
                        <img
                          src={Logo}
                          alt="Borderless Money"
                          width={120}
                          height={80}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-3 font-geomanistregular text-xs leading-4 text-[#767c8f]">
              {themeData?.data?.name ?? ""}
              &nbsp; has partnered with Borderless to offer this multi-currency
              account. With this account, you can:
            </div>

            <div className="flex flex-col gap-1 mt-4">
              <div className="flex items-center gap-2">
                <img
                  src={planTick}
                  alt="plan-tick"
                  className="w-[15px] h-[15px]"
                />
                <span className="font-geomanistRegular text-xs leading-4 text-[#3c404a]">
                  Save, spend and invest in 6 currencies
                </span>
              </div>
              <div className="flex items-center gap-2">
                <img
                  src={planTick}
                  alt="plan-tick"
                  className="w-[15px] h-[15px]"
                />
                <span className="font-geomanistRegular text-xs leading-4 text-[#3c404a]">
                  Pay rent and everyday expenses
                </span>
              </div>
              <div className="flex items-center gap-2">
                <img
                  src={planTick}
                  alt="plan-tick"
                  className="w-[15px] h-[15px]"
                />
                <span className="font-geomanistRegular text-xs leading-4 text-[#3c404a]">
                  Send tuition fees directly to your university
                </span>
              </div>
              <div className="flex items-center gap-2">
                <img
                  src={planTick}
                  alt="plan-tick"
                  className="w-[15px] h-[15px]"
                />
                <span className="font-geomanistRegular text-xs leading-4 text-[#3c404a]">
                  Use a debit card for seamless payments
                </span>
              </div>
            </div>

            <div className="flex items-center justify-center mt-6 cursor-pointer">
              <div
                className={` w-full h-10 rounded-[7.5px] py-1 px-8 bg-[#0062e2] flex justify-center items-center ${
                  isLoading ? "cursor-not-allowed" : "cursor-pointer"
                }`}
                onClick={!isLoading ? handleRedirectAction : undefined}
              >
                {isLoading ? (
                  <span className="border-2 border-[#f3f3f3] border-t-[#0f62fe] rounded-full w-4 h-4 animate-spin inline-block"></span>
                ) : (
                  <span className="text-sm leading-4 text-white font-geomanistbook">
                    Let's Begin
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
  // )
};

export default BorderlessMoneyBanner;
